
import { defineComponent } from "vue";
import BaseIcon from "./base-icon.vue";

export default defineComponent({
  components: { BaseIcon },
});
